import { render, staticRenderFns } from "./PaymentElementCard.vue?vue&type=template&id=f45687d0&scoped=true"
import script from "./PaymentElementCard.vue?vue&type=script&lang=js"
export * from "./PaymentElementCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentElementCard.vue?vue&type=style&index=0&id=f45687d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45687d0",
  null
  
)

export default component.exports